import React, { useState } from "react";
import { Card, CardHeader, CardBody, CardFooter, Typography, Button, Tooltip, IconButton, Chip } from "@material-tailwind/react";
import { orderStages } from "assets/orderStages";
import Lottie from "react-lottie";
import { ChevronDownIcon, ChevronUpIcon, HeartIcon, StarIcon } from "@heroicons/react/24/solid";

import OrderStage1 from "./FeaturedOrderStages/OrderStage1";
import OrderStage2 from "./FeaturedOrderStages/OrderStage2";
import OrderStage3 from "./FeaturedOrderStages/OrderStage3";
import OrderStage4 from "./FeaturedOrderStages/OrderStage4";
import OrderStage5 from "./FeaturedOrderStages/OrderStage5";
import OrderStage6 from "./FeaturedOrderStages/OrderStage6";
import OrderStage7 from "./FeaturedOrderStages/OrderStage7";
import OrderStage8 from "./FeaturedOrderStages/OrderStage8";
import OrderStage9 from "./FeaturedOrderStages/OrderStage9";
import OrderStage10 from "./FeaturedOrderStages/OrderStage10";
import OrderStage11 from "./FeaturedOrderStages/OrderStage11";
import OrderStage12 from "./FeaturedOrderStages/OrderStage12";
import OrderStage13 from "./FeaturedOrderStages/OrderStage13";

import OrderStageAnimation1 from "./OrderStageAnimations/OrderStageAnimation1.json";
import OrderStageAnimation2 from "./OrderStageAnimations/OrderStageAnimation2.json";
import OrderStageAnimation3 from "./OrderStageAnimations/OrderStageAnimation3.json";
import OrderStageAnimation4 from "./OrderStageAnimations/OrderStageAnimation4.json";
import OrderStageAnimation5 from "./OrderStageAnimations/OrderStageAnimation5.json";
import OrderStageAnimation6 from "./OrderStageAnimations/OrderStageAnimation6.json";
import OrderStageAnimation7 from "./OrderStageAnimations/OrderStageAnimation7.json";
import OrderStageAnimation8 from "./OrderStageAnimations/OrderStageAnimation8.json";
import OrderStageAnimation9 from "./OrderStageAnimations/OrderStageAnimation9.json";
import OrderStageAnimation10 from "./OrderStageAnimations/OrderStageAnimation10.json";
import OrderStageAnimation11 from "./OrderStageAnimations/OrderStageAnimation11.json";
import OrderStageAnimation12 from "./OrderStageAnimations/OrderStageAnimation12.json";
import OrderStageAnimation13 from "./OrderStageAnimations/OrderStageAnimation13.json";

// Create a switch-statement for the 13 stages to render it as the featured stage

export default function FeaturedOrderStage() {
  const [showContent, setShowContent] = useState(true);

  function handleToggle() {
    setShowContent(!showContent);
  }
  const currentStage = 4;
  const stage = orderStages[currentStage];

  const lottieOptions = {
    loop: true,
    autoplay: true,
    animationData: OrderStageAnimation4,
  };

  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";
  const buttonStyles = `w-full flex items-stretch justify-between py-4 px-6 ${showContent ? "border-b border-b-gray-300" : ""}`;

  return (
    <div className={containerStyles}>
      <button className={buttonStyles} onClick={handleToggle}>
        <header className="flex items-center flex-1">
          <div className="bg-blue-600 rounded-lg p-1 flex items-center justify-center h-[25px] w-[25px] mr-2">
            <StarIcon className="h-3 w-3 text-white" />
          </div>
          <h3 className="text-lg font-semibold">Current Stage</h3>
        </header>
        <footer className="flex items-center ">
          {showContent ? <ChevronUpIcon className="block h-4 w-4" /> : <ChevronDownIcon className="block h-4 w-4" />}
        </footer>
      </button>
      {showContent ? (
        <div className="p-6">
          <h2 className="text-xl font-bold mb-2">{stage.title}</h2>
          <div className="text-sm leading-6">{stage.message}</div>
          <div className="my-6">
            <Lottie options={lottieOptions} style={{ height: 250 }} />
          </div>
          <div className="flex justify-center">
            <Button size="md" className="bg-blue-700 hover:bg-blue-800 rounded-full">
              {stage.cta}
            </Button>
          </div>
        </div>
      ) : null}
    </div>
  );
}
